import { RoleType, User } from "../@types/Auth";

export const isMadJaxAdmin = (user: User | undefined): boolean => {
    const userRoleType = user?.attributes.type ?? '';
    return userRoleType === RoleType.Admin;
}